export default __webpack_public_path__ + "static/media/Affrescati_dettagli_crepa_01.e6d9e5a2.jpg";